import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { georgeWebHeaderStore } from "components/common/GeorgeWebHeader";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { AppStoreRedirectStoreDeprecated } from "../appStoreRedirectDeprecated/AppStoreRedirectStoreDeprecated";
import { AppStoreRedirectRoutes } from "./AppStoreRedirectRoutesNew";
import { AppStoreRedirectSite } from "./AppStoreRedirectSiteNew";

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// This is the App Store Redirect Container running in PROD /georgeapp
// It is using the DEPRECATED App Store Redirect Store for the URL handling 
// 
// TODO: This needs to be changed to the new version once the tests are successful. @Bleron 30.04.2026 needs to give this free
//
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class AppStoreRedirectContainer extends React.Component<IProps> {
    store: AppStoreRedirectStoreDeprecated;

    constructor(props: IProps) {
        super(props);
        this.store = new AppStoreRedirectStoreDeprecated();
    }

    async componentDidMount() {
        pushRoute(AppStoreRedirectRoutes.ROOT);
        try {
            georgeWebHeaderStore.configure({
                title: ui.__("appStoreRedirect.document.title"),
            });
        } catch (error) {
            debug.log("### AppStoreRedirectContainer.componentDidMount() Failed to load data", error);

            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        document.title = ui.__("appStoreRedirect.document.title");
        return (
            <div>
                <Route exact path={AppStoreRedirectRoutes.ROOT} component={this.withStore(AppStoreRedirectSite)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/appStoreRedirect/AppStoreRedirectContainer.tsx